import { render, staticRenderFns } from "./FormularioTerceiro.vue?vue&type=template&id=30c2bb1e&scoped=true"
import script from "./FormularioTerceiro.vue?vue&type=script&lang=js"
export * from "./FormularioTerceiro.vue?vue&type=script&lang=js"
import style0 from "./FormularioTerceiro.vue?vue&type=style&index=0&id=30c2bb1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c2bb1e",
  null
  
)

export default component.exports